import URLS from './modules/urls';
import { LANGUAGE_LIST, LANGUAGE_LOCALE_MAPPING } from './modules/language-list';
import NAV_LIST from './modules/nav-list';
import { PermissionCode, hasPermission, hasAnyPermission } from './modules/permission';
const LOGIN_EXPIRES = 5; // 天
export { URLS, LOGIN_EXPIRES, LANGUAGE_LIST, LANGUAGE_LOCALE_MAPPING, NAV_LIST, PermissionCode, hasPermission, hasAnyPermission, };
